import { memo, useCallback, useState } from "react";
import { CustomTaskDescription } from "@coworker/apprestructured/src/task-management/components/CustomTaskDescription/CustomTaskDescription";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import ChecklistItem from "@coworker/apprestructured/src/task-management/types/ChecklistItem";

function CustomTaskDescriptionDemo() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [checklist, setChecklist] = useState<ChecklistItem[]>([]);
  const [showValidation, setShowValidation] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const handleConfirmClick = useCallback(
    ({
      title,
      description,
      checklist,
    }: {
      title: string;
      description: string;
      checklist: ChecklistItem[];
    }) => {
      setTitle(title);
      setDescription(description);
      setChecklist(checklist);
    },
    []
  );

  return (
    <Demo>
      <Name>CustomTaskDescription</Name>
      <Highlight>
        <FixaListView id="CustomTaskDescription" size="small">
          <CustomTaskDescription
            title={title}
            onConfirmClick={handleConfirmClick}
            description={description}
            checklist={checklist}
            disabled={disabled}
            showValidation={showValidation}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="customtaskdescriptiondemo-disabled"
          id="customtaskdescriptiondemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
        <FixaCheckbox
          label="showValidation"
          value="customtaskdescriptiondemo-showValidation"
          id="customtaskdescriptiondemo-showValidation"
          checked={showValidation}
          onChange={() => setShowValidation((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(CustomTaskDescriptionDemo);
